import { AttachmentModel } from '../Case/CaseDetailsModel';

export enum NachrichtType {
  BESCHEID_DIGITAL,
  BESCHEID_POSTALISCH,
  NACHRICHT_DIGITAL
}

export enum VersandStatus {
  SCHEDULED = 'SCHEDULED',
  DISPATCHING = 'DISPATCHING',
  DISPATCHED = 'DISPATCHED',
  SUCCESSFUL = 'SUCCESSFUL',
  FAILED = 'FAILED',
  CANCELED = 'CANCELED',
  OVERDUE = 'OVERDUE'
}

export enum VersandChannel {
  FITCONNECT = 'FITCONNECT',
  BUNDID = 'BUNDID',
  POSTAL = 'POSTAL'
}

export interface VersandStatusModel {
  status: VersandStatus;
  channel: VersandChannel;
  userId: string | null;
  postalSwitchable: boolean;
}

export interface NachrichtModel {
  submissionId: string;
  betreff: string;
  isBescheid: boolean;
  nachrichtType: NachrichtType;
  absenderName: string;
  createdOn: Date;
  hasAttachments: boolean;
  attachment: Array<AttachmentModel>;
  isVonBehoerde: boolean;
  nachrichtBody: string;
  isHtml: boolean;
  isSubmission: boolean;
  organisationUnitName: string;
  isSelected: boolean;
  hasBeenRead: boolean;
  versandStatus: VersandStatusModel | null;
}
